import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

export function RecaptchaDisclaimer({ className }: { className?: string }): JSX.Element {
    return (
        <p className={twMerge(className, 'text-gray-700 text-sm dark:text-neutral-dark-1000')}>
            This site is protected by reCAPTCHA.
        </p>
    );
}
